import { render, staticRenderFns } from "./chargement.vue?vue&type=template&id=f5e89f34"
import script from "./chargement.vue?vue&type=script&lang=js"
export * from "./chargement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports